/* custom code start */
if (!customElements.get("home-featured-collections")) {
  class HomeFeaturedCollections extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll(".hfc-tab"));
      this.swiperEl = this.querySelector("swiper-component");
      this.slides = Array.from(this.querySelectorAll(".hfc-slide"));

      this.onTabClick = this.onTabClick.bind(this);
      this.onTabKeydown = this.onTabKeydown.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      // Theme editor: focus the selected collection block's tab + slide
      this.addEventListener("shopify:block:select", this.onBlockSelect);

      if (this.tabs.length === 0) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener("click", this.onTabClick);
        tab.addEventListener("keydown", this.onTabKeydown);
      });

      // Sync to whichever tab Liquid marked active on first paint
      const active = this.tabs.find((t) => t.classList.contains("is-active")) || this.tabs[0];
      this.activate(active, { animate: false });
    }

    disconnectedCallback() {
      this.removeEventListener("shopify:block:select", this.onBlockSelect);
      this.tabs.forEach((tab) => {
        tab.removeEventListener("click", this.onTabClick);
        tab.removeEventListener("keydown", this.onTabKeydown);
      });
    }

    getSwiper() {
      if (!this.swiperEl) return null;
      return this.swiperEl.swiper || this.swiperEl.swiperInstance || null;
    }

    onTabClick(event) {
      this.activate(event.currentTarget, { animate: true });
    }

    onTabKeydown(event) {
      const index = this.tabs.indexOf(event.currentTarget);
      let next = null;

      switch (event.key) {
        case "ArrowRight":
        case "ArrowDown":
          next = this.tabs[(index + 1) % this.tabs.length];
          break;
        case "ArrowLeft":
        case "ArrowUp":
          next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
          break;
        case "Home":
          next = this.tabs[0];
          break;
        case "End":
          next = this.tabs[this.tabs.length - 1];
          break;
        default:
          return;
      }

      event.preventDefault();
      next.focus();
      this.activate(next, { animate: true });
    }

    onBlockSelect(event) {
      const slide = event.target.closest(".hfc-slide");
      if (!slide) return;

      // Activate the tab this slide belongs to, then scroll to the slide itself
      const category = slide.dataset.category;
      const tab = this.tabs.find((t) => t.dataset.category === category);

      if (tab) {
        this.activate(tab, { animate: true, targetSlide: slide });
      } else {
        this.slideTo(slide, true);
      }
    }

    activate(tab, { animate = true, targetSlide = null } = {}) {
      const category = tab.dataset.category;

      this.tabs.forEach((t) => {
        const isActive = t === tab;
        t.classList.toggle("is-active", isActive);
        t.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      this.slides.forEach((slide) => {
        slide.classList.toggle("hfc-slide--hidden", slide.dataset.category !== category);
      });

      const swiper = this.getSwiper();
      if (swiper) swiper.update();

      if (targetSlide) {
        this.slideTo(targetSlide, animate);
      } else if (swiper) {
        swiper.slideTo(0, animate ? 300 : 0);
      }
    }

    slideTo(slide, animate) {
      const swiper = this.getSwiper();
      if (!swiper) return;
      const index = Array.prototype.indexOf.call(swiper.slides, slide);
      swiper.slideTo(index >= 0 ? index : 0, animate ? 300 : 0);
    }
  }

  customElements.define("home-featured-collections", HomeFeaturedCollections);
}
/* custom code end */
